module.exports = __webpack_public_path__ + "img/logo.462f0b15.svg";